var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { Kpi, KpiItem } from '../../../models/common';
import { PostType } from '../../../models/post-overview';
import { InfluencerPostService } from '../../services/influencer-post/influencer-post.service';
import { CommonService } from '../../services/common/common.service';
import { InfluencerService } from '../../services/influencer/influencer.service';
import { chartConfig, CommonConstant, platformIconPath } from '../../app.constants';
import { PlaceholderVisibilityService } from '../../services/placeholder-visibility/placeholder-visibility.service';
import { UserService } from '../../services/user.service';
import { CampaignService } from '../../services/campaign/campaign.service';
import { AddInfluencersCampaign } from '../../../models/campaign/add-influencers-campaign';
import { AchooPopupComponent } from '../../core/achoo-popup/achoo-popup.component';
import { ModalService } from '../../services/modal/modal.service';
import { Project } from '../../../models/project/project';
import { ReferenceDataService } from '../../services/reference-data/reference-data.service';
import { DiscoverService } from '../../services/discover/discover.service';
import { PdfViewerService } from '../pdf-viewer/pdf-viewer.service';
import { PdfExportService } from '../../services/export-pdf/pdf-export.service';
import { AbstractAchooComponent } from '../abstract-achoo.component';
import { ActionDetails, ActionSource, ActivePages, EventTrackerService, Page, TargetType, UserActionType } from '../../services/event-tracker/event-tracker.service';
import { NumberUtils } from '../../utils/number.utils';
import { TranslateService } from '@ngx-translate/core';
import { ObjectUtils } from '../../utils/object.utils';
import { CacheService } from '../../services/cache/cache.service';
import { CampaignsDetailComponent } from '../campaigns-add/campaign-detail.component';
var PostOverviewComponent = /** @class */ (function (_super) {
    __extends(PostOverviewComponent, _super);
    function PostOverviewComponent(route, router, location, influencerPostService, commonService, influencerService, userService, campaignService, referenceDataService, discoverService, modalService, placeholderService, pdfViewerService, pdfService, translate, cacheService, eventTracker) {
        var _this = _super.call(this, userService) || this;
        _this.route = route;
        _this.router = router;
        _this.location = location;
        _this.influencerPostService = influencerPostService;
        _this.commonService = commonService;
        _this.influencerService = influencerService;
        _this.userService = userService;
        _this.campaignService = campaignService;
        _this.referenceDataService = referenceDataService;
        _this.discoverService = discoverService;
        _this.modalService = modalService;
        _this.placeholderService = placeholderService;
        _this.pdfViewerService = pdfViewerService;
        _this.pdfService = pdfService;
        _this.translate = translate;
        _this.cacheService = cacheService;
        _this.eventTracker = eventTracker;
        _this.topExposures = [];
        _this.platforms = [];
        _this.selectedCampaign = new AddInfluencersCampaign();
        _this.newProject = new Project();
        _this.hideBackButton = false;
        _this.pieLegend = {};
        _this.enagagementChartConfig = {
            spacingTop: 8
        };
        // flag to indicate whether we on Media Platform or Influencer Platform
        // Default on Media Platform
        _this.onInfluencerPlatform = false;
        return _this;
    }
    PostOverviewComponent.prototype.ngOnInit = function () {
        var _this = this;
        _super.prototype.ngOnInit.call(this);
        this.route.data.subscribe(function (data) {
            if (data.onInfluencerPlatform) {
                _this.onInfluencerPlatform = true;
                _this.initializePostPageForInfluencerPlatform();
            }
            else {
                _this.onInfluencerPlatform = false;
                _this.intializePostPageForMediaPlatform();
            }
        });
        // get list countries
        this.countryList = this.referenceDataService.countries;
    };
    PostOverviewComponent.prototype.intializePostPageForMediaPlatform = function () {
        var _this = this;
        this.route.queryParamMap.subscribe(function (params) {
            var influencerId = params.get('influencerId');
            var urlHash = params.get('urlHash');
            _this.hideBackButton = params.get('hideBackButton') && (params.get('hideBackButton') === 'true');
            _this.fromPath = params.get('from_path');
            _this.influencerId = Number(influencerId);
            _this.influencerGroupId = Number(params.get('influencerGroupId'));
            _this.placeholderService.show(CommonConstant.INFLUENCER_BASIC_INFORMATION_HOLDER);
            _this.getInfluencerDetails(influencerId);
            if (urlHash) {
                _this.getPostContent(urlHash, influencerId);
                _this.getRelatedPosts(Number(influencerId));
            }
        });
    };
    PostOverviewComponent.prototype.initializePostPageForInfluencerPlatform = function () {
        var _this = this;
        this.route.params.subscribe(function (params) {
            var urlHash = params.urlHash;
            var currentInfluencer = _this.userService.getInfluencerInfo();
            if (currentInfluencer) {
                _this.influencerId = currentInfluencer.id;
                _this.getInfluencerDetails(currentInfluencer.id);
                _this.getPostContent(urlHash, currentInfluencer.id);
                _this.getRelatedPosts(Number(currentInfluencer.id));
            }
        });
    };
    // callback when switching account
    PostOverviewComponent.prototype.companyChangeCallback = function (companyId) {
        var _this = this;
        this.cacheService.get("campaign_short_list_" + companyId, this.campaignService.getCampaignShortListForCompany(companyId)).subscribe(function (res) {
            _this.campaignList = res.map(function (campaign) { return ({
                id: campaign.id,
                name: campaign.name,
                brief: campaign.brief
            }); });
        });
        // load list project
        this.cacheService.get("all_projects_of_advertiser_" + companyId, this.userService.getAllProjectOfAdvertiser()).subscribe(function (res) {
            if (!res || !res.data) {
                _this.projectList = [];
            }
            else {
                _this.projectList = res.data.map(function (prj) { return ({
                    id: prj.id,
                    name: prj.name,
                    countries: prj.projectCountries.map(function (item) { return item.country.id; }),
                    keywords: prj.projectKeywords.map(function (item) { return item.keyword; })
                }); });
            }
        });
    };
    PostOverviewComponent.prototype.getInfluencerDetails = function (influencerId) {
        var _this = this;
        this.cacheService.get("influencer_" + influencerId, this.influencerService.getInfluencer(influencerId)).subscribe(function (data) {
            _this.influencer = data;
            _this.showCountryFlagIcon = true;
            _this.placeholderService.hide(CommonConstant.INFLUENCER_BASIC_INFORMATION_HOLDER);
        });
    };
    PostOverviewComponent.prototype.getPostContent = function (urlHash, influencerId) {
        var _this = this;
        this.cacheService.get("post_" + urlHash, this.influencerPostService.getPostContent(urlHash, influencerId)).subscribe(function (data) {
            _this.postContent = data;
            if (!_this.postContent) {
                return _this.handleNotFoundPost();
            }
            var platform = _this.postContent.channel ? _this.postContent.channel.platform : _this.postContent.platform;
            _this.platformIconUrl = _this.commonService.resolvePlatformIconUrl(platform.name);
            _this.postActivityGaugeChartData = _this.postContent.story && !_this.postContent.authorized ? [] : _this.extractGaugeChartData(_this.postContent);
            _this.postKpi = _this.extractGlobalKpi(_this.postContent);
            if (_this.postContent.urlHash) {
                _this.getPostDailyKpis(_this.postContent.urlHash, influencerId, _this.postContent);
            }
            // segment track event
            _this.eventTracker.trackUserAction(UserActionType.VIEW, Page.POST, {
                id: _this.postContent.urlHash,
                name: _this.postContent.title,
                type: TargetType.POST
            }, undefined, undefined, _this.activePage);
        });
    };
    PostOverviewComponent.prototype.handleNotFoundPost = function () {
        if (this.onInfluencerPlatform) {
            return this.router.navigate(['dashboard', 'details']);
        }
        else {
            return this.router.navigate(['influencer', this.influencerId]);
        }
    };
    PostOverviewComponent.prototype.extractGaugeChartData = function (postContent) {
        var gaugeChartData = new Array();
        if (postContent.comments === 0 && postContent.playlists === 0 && postContent.dislikes === 0
            && postContent.shares === 0 && postContent.views === 0 && postContent.likes === 0) {
            return gaugeChartData;
        }
        var totalEngagements = postContent.comments + postContent.playlists + postContent.dislikes + postContent.shares + postContent.views + postContent.likes + postContent.replies;
        if (postContent.story && postContent.authorized) {
            totalEngagements = totalEngagements + postContent.tapsBack + postContent.tapsForward + postContent.exits;
        }
        if (postContent.postType === PostType.REEL) {
            totalEngagements += postContent.plays;
        }
        if (totalEngagements === 0) {
            return gaugeChartData;
        }
        if (postContent.views > 0) {
            gaugeChartData.push({
                name: 'Views',
                y: postContent.views / totalEngagements,
                fracDigit: 1
            });
        }
        if (postContent.likes > 0) {
            gaugeChartData.push({
                name: 'Likes',
                y: postContent.likes / totalEngagements,
                fracDigit: 1
            });
        }
        if (postContent.dislikes > 0) {
            gaugeChartData.push({
                name: 'Dislikes',
                y: postContent.dislikes / totalEngagements,
                fracDigit: 1
            });
        }
        if (postContent.comments > 0) {
            gaugeChartData.push({
                name: 'Comments',
                y: postContent.comments / totalEngagements,
                fracDigit: 1
            });
        }
        if (postContent.replies > 0) {
            gaugeChartData.push({
                name: 'Replies',
                y: postContent.replies / totalEngagements,
                fracDigit: 1
            });
        }
        if (postContent.shares > 0) {
            gaugeChartData.push({
                name: 'Shares',
                y: postContent.shares / totalEngagements,
                fracDigit: 1
            });
        }
        if (postContent.playlists > 0) {
            gaugeChartData.push({
                name: 'Playlists',
                y: postContent.playlists / totalEngagements,
                fracDigit: 1
            });
        }
        if (postContent.postType === PostType.REEL && postContent.plays > 0) {
            gaugeChartData.push({
                name: this.translate.instant('page.post_overview.section_legend.plays'),
                y: postContent.plays / totalEngagements,
                fracDigit: 1
            });
        }
        if (postContent.story && postContent.authorized) {
            gaugeChartData = gaugeChartData.concat(this.addNewTypeToGaugeChartData(postContent, totalEngagements));
        }
        return gaugeChartData;
    };
    PostOverviewComponent.prototype.addNewTypeToGaugeChartData = function (postContent, totalEngagements) {
        var gaugeChartDataWithNewType = new Array();
        if (postContent.tapsBack > 0) {
            gaugeChartDataWithNewType.push({
                name: this.translate.instant('page.post_overview.section_legend.taps_back'),
                y: postContent.tapsBack / totalEngagements,
                fracDigit: 1
            });
        }
        if (postContent.tapsForward > 0) {
            gaugeChartDataWithNewType.push({
                name: this.translate.instant('page.post_overview.section_legend.taps_forward'),
                y: postContent.tapsForward / totalEngagements,
                fracDigit: 1
            });
        }
        if (postContent.exits > 0) {
            gaugeChartDataWithNewType.push({
                name: this.translate.instant('page.post_overview.section_legend.exits'),
                y: postContent.exits / totalEngagements,
                fracDigit: 1
            });
        }
        return gaugeChartDataWithNewType;
    };
    PostOverviewComponent.prototype.extractGlobalKpi = function (postContent) {
        var impression = new KpiItem();
        impression.name = 'impresions';
        impression.value = postContent.impression;
        // the fallback value of IG impression value is reach
        if (postContent.impression === 0 && postContent.platform && postContent.platform.id === platformIconPath.instagram.id) {
            impression.value = postContent.reach;
        }
        var reach = new KpiItem();
        reach.name = 'reach';
        reach.value = postContent.reach;
        var engagement = new KpiItem();
        engagement.name = 'engagement';
        engagement.value = postContent.engagement;
        var impact = new KpiItem();
        impact.name = 'impact';
        impact.value = postContent.impact * 100;
        var globalKpi = new Kpi();
        globalKpi.engagement = engagement;
        globalKpi.reach = reach;
        globalKpi.impact = impact;
        globalKpi.impressions = impression;
        return globalKpi;
    };
    PostOverviewComponent.prototype.getPostDailyKpis = function (urlHash, influencerId, currentPost) {
        var _this = this;
        var today = new Date();
        today.setDate(today.getDate() - 30);
        var startDate = today.toISOString().split('T')[0];
        this.cacheService.get("post_daily_kpis_" + urlHash, this.influencerPostService.getPostDailyKpis(urlHash, influencerId, 30, startDate, null)).subscribe(function (res) {
            if (res) {
                var chartData = res.chartData;
                _this.postActivityLineChartData = _this.commonService.normalizeDataForActivityLineChart(chartData);
                if (res.currentPost && res.currentPost.length > 0) {
                    var currentPostDaily = res.currentPost[0];
                    var currentPostDailyDate = new Date(currentPostDaily.date);
                    var reachPoint = _this.buildLineChartPoint('Reach Point', CommonConstant.REACHE_LINE_COLOR);
                    reachPoint.data.push([currentPostDailyDate.getTime(), currentPostDaily.reach]);
                    var impressionPoint = _this.buildLineChartPoint('Impression Point', CommonConstant.IMPRESSION_LINE_COLOR);
                    impressionPoint.data.push([currentPostDailyDate.getTime(), currentPostDaily.impression]);
                    var engagementPoint = _this.buildLineChartPoint('Engagement Point', CommonConstant.ENGAGEMENT_LINE_COLOR);
                    engagementPoint.data.push([currentPostDailyDate.getTime(), currentPostDaily.engagement]);
                    _this.postActivityLineChartData.splice(0, 0, reachPoint);
                    _this.postActivityLineChartData.splice(0, 0, impressionPoint);
                    _this.postActivityLineChartData.splice(0, 0, engagementPoint);
                }
            }
        });
    };
    PostOverviewComponent.prototype.buildLineChartPoint = function (name, color) {
        return {
            name: name,
            data: [],
            color: color,
            marker: {
                enable: true,
                fillColor: color,
                radius: 6,
            },
            showInLegend: false,
            dataLabels: {
                y: -5,
                enabled: true,
                useHTML: true,
                allowOverlap: true,
                formatter: function () {
                    return '<div class="current-post-daily-kpi">' +
                        '<span class="kpi-content">' + NumberUtils.normalizeNumberToString(this.y) + '</span>' +
                        '<span class="bottom-arrow"></span>' +
                        '</div>';
                },
                style: {
                    fontFamily: chartConfig.font.light,
                    fontSize: '0.99rem',
                    color: '#717D8D',
                    top: '19px'
                }
            }
        };
    };
    PostOverviewComponent.prototype.getRelatedPosts = function (influencerId) {
        var _this = this;
        this.cacheService.get("related_posts_" + influencerId, this.influencerPostService.getRelatedPosts(influencerId)).subscribe(function (res) {
            _this.topExposures = res;
        });
    };
    PostOverviewComponent.prototype.back = function () {
        if (!this.postContent) {
            return this.location.back();
        }
        this.cacheService.disableCacheRemoving(this.cachedKeys(this.postContent.urlHash, this.postContent.influencerId, this.companyId));
        if (this.fromPath) {
            var fromPathUrl = this.fromPath.split('?')[0];
            var fromPathRequestParams = ObjectUtils.parseRequestParamFromString(this.fromPath.split('?')[1], '=');
            return this.router.navigate([fromPathUrl], { queryParams: fromPathRequestParams });
        }
        else {
            return this.location.back();
        }
    };
    PostOverviewComponent.prototype.cachedKeys = function (urlHash, influencerId, companyId) {
        return [
            "related_posts_" + influencerId,
            "post_daily_kpis_" + urlHash,
            "campaign_short_list_" + companyId,
            "all_projects_of_advertiser_" + companyId,
            "influencer_" + influencerId,
            "post_" + urlHash,
            "post_daily_kpis_" + urlHash
        ];
    };
    PostOverviewComponent.prototype.hideAlertSuccess = function () {
        this.modalService.close();
    };
    PostOverviewComponent.prototype.hideBottomBar = function () {
        this.activeBottomBar = false;
        this.isEnableAddToCampaign = false;
        this.isEnableAddToProject = false;
    };
    PostOverviewComponent.prototype.showAddToCampaign = function () {
        this.activeBottomBar = true;
        this.isEnableAddToCampaign = true;
    };
    PostOverviewComponent.prototype.showAddToProject = function () {
        this.activeBottomBar = true;
        this.isEnableAddToProject = true;
    };
    PostOverviewComponent.prototype.addInfluencerToCampaign = function (addInfluencerCampaign) {
        var _this = this;
        var postPaths = [{
                urlHash: this.postContent.urlHash,
                influencerId: this.postContent.influencerId,
                url: this.postContent.url,
                relativepath: this.postContent.relativePath,
                publishDate: this.postContent.publishedDate,
                title: this.postContent.title,
                image: this.postContent.image,
                status: addInfluencerCampaign.is_accepted ? 'accepted' : 'invited',
                channelId: this.postContent.channel ? this.postContent.channel.id : null
            }];
        this.hideBottomBar();
        this.selectedCampaign = addInfluencerCampaign;
        this.selectedCampaignNotificationMsg = addInfluencerCampaign.campaign_name;
        this.campaignService.addPostsToCampaign(addInfluencerCampaign.campaign_id, postPaths).subscribe(function (res) {
            _this.showAlertSuccessAddInfluencerToCampaign();
            // track event to Segment
            _this.eventTracker.trackUserAction(UserActionType.ACTION, Page.CAMPAIGN, {
                id: addInfluencerCampaign.campaign_id,
                name: addInfluencerCampaign.campaign_name,
                type: TargetType.CAMPAIGN
            }, __assign({ action: UserActionType.UPDATE, source: ActionSource.PAGE, actionDetails: ActionDetails.ADDED_POSTS }, addInfluencerCampaign, { postUrlHash: _this.postContent.urlHash, postTitle: _this.postContent.title }), undefined, _this.activePage);
            _this.userService.triggerUpdateActivatedInfluencers();
        }, function (error) {
            _this.showAddToCampaign();
            var serverError = CampaignsDetailComponent.buildMessageErrorInArchive(error.error, _this.translate);
            if (serverError.errorType === 'invalid level') {
                _this.userService.doInvalidActionByLevel(CommonConstant.BASIC_CAMPAIGN_ACTION, serverError.errorMsg);
            }
            else {
                _this.showAlertErrorAddInfluencerToCampaign();
            }
        });
    };
    PostOverviewComponent.prototype.showAlertSuccessAddInfluencerToCampaign = function () {
        this.modalService.open(this.alertAddPostToCampaignSuccess, undefined, true);
    };
    PostOverviewComponent.prototype.showAlertErrorAddInfluencerToCampaign = function () {
        this.modalService.open(this.alertAddPostToCampaignError, undefined, true);
    };
    PostOverviewComponent.prototype.showCreateProjectFragement = function () {
        // initialize value for new project
        this.newProject = new Project();
        this.newProject.id = 0;
        this.newProject.countries = [];
        // show project creation fragment
        this.isEnableAddToProject = false;
        this.showCreateNewProjectFragment = true;
    };
    PostOverviewComponent.prototype.afterCreateProjectSuccess = function (newPersistedProject) {
        if (newPersistedProject.isReloadList) {
            var newProject = new Project();
            newProject.name = newPersistedProject.projectName;
            newProject.id = newPersistedProject.projectId;
            newProject.countries = newPersistedProject.projectData.projectCountries.map(function (item) { return item.country.id; });
            newProject.keywords = newPersistedProject.projectData.projectKeywords.map(function (item) { return item.keyword; });
            this.projectList.push(newProject);
        }
        this.showCreateNewProjectFragment = false;
        this.isEnableAddToProject = true;
    };
    /**
     * using to add multiple post into project
     * @param {AddPostToProject} addPostToProject
     */
    PostOverviewComponent.prototype.addPostIntoProject = function (addPostToProject) {
        var _this = this;
        var postData = [{
                postUrlHash: this.postContent.urlHash,
                postRelativePath: this.postContent.relativePath,
                channelId: this.postContent.channel ? this.postContent.channel.id : null
            }];
        addPostToProject.posts = postData;
        this.discoverService.addPostsToProject(addPostToProject).subscribe(function (res) {
            _this.showNotificationAfterAddingPostToProject(addPostToProject.projectName);
            _this.hideBottomBar();
            // track event to Segment
            _this.eventTracker.trackUserAction(UserActionType.ACTION, Page.PROJECT, {
                id: addPostToProject.projectId,
                name: addPostToProject.projectName,
                type: TargetType.PROJECT
            }, __assign({ action: UserActionType.UPDATE, source: ActionSource.PAGE, actionDetails: ActionDetails.ADDED_POSTS }, addPostToProject, { postUrlHash: _this.postContent.urlHash, postTitle: _this.postContent.title }), undefined, _this.activePage);
        });
    };
    PostOverviewComponent.prototype.showNotificationAfterAddingPostToProject = function (projectName) {
        this.projectName = projectName;
        this.modalService.open(this.notificationAfterAddPostToProject, undefined, true);
    };
    PostOverviewComponent.prototype.exportPDF = function (popper) {
        var _this = this;
        // cancel previous request
        if (this.exportPdfSubcription) {
            this.exportPdfSubcription.unsubscribe();
        }
        if (popper) {
            popper.hide();
        }
        this.modalService.open(this.alertPdfDownloadPending, null, true, CommonConstant.PDF_EXPORT_NOTIFICATION_SHOWING_TIME);
        var params = {
            influencerId: this.postContent.influencerId,
            urlHash: this.postContent.urlHash,
            activeAccount: this.userService.getCompanyId(),
            fullUrl: this.postContent.url,
            relativePath: this.postContent.relativePath
        };
        this.exportPdfSubcription = this.pdfViewerService.generatePostOverviewPdf(params, this.userService.getCompanyId()).subscribe(function (res) {
            // track event to Segment
            _this.eventTracker.trackUserAction(UserActionType.ACTION, Page.POST, {
                id: _this.postContent.urlHash,
                name: _this.postContent.title,
                type: TargetType.POST
            }, {
                action: UserActionType.EXPORT,
                source: ActionSource.BOTTOM_BAR,
            }, undefined, _this.activePage);
        });
    };
    PostOverviewComponent.prototype.backToDashboard = function () {
        return this.router.navigate(['dashboard', 'home']);
    };
    Object.defineProperty(PostOverviewComponent.prototype, "activePage", {
        get: function () {
            return {
                type: ActivePages.POST,
                name: this.postContent.title,
                id: this.postContent.urlHash
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PostOverviewComponent.prototype, "isFreeUser", {
        get: function () {
            return this.userService.isFreeUser();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PostOverviewComponent.prototype, "shouldShowFreemiumFallbackMessage", {
        get: function () {
            return this.isFreeUser && !this.userService.isAdmin;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PostOverviewComponent.prototype, "fallbackTitle", {
        get: function () {
            if (this.userService.isFreeUser() && !this.userService.isAdmin) {
                return this.translate.instant('common.invalid_action_by_levels_warning.fallback_title');
            }
            else {
                return null;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PostOverviewComponent.prototype, "fallbackMessage", {
        get: function () {
            if (this.userService.isFreeUser() && !this.userService.isAdmin) {
                return this.translate.instant('common.invalid_action_by_levels_warning.fallback_message');
            }
            else {
                return null;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PostOverviewComponent.prototype, "enagagementFallbackTitle", {
        get: function () {
            if (!this.postContent || (this.isFreeUser && !this.userService.isAdmin)) {
                return null;
            }
            return this.translate.instant('story.engagement.fallback_title');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PostOverviewComponent.prototype, "enagagementFallbackMessage", {
        get: function () {
            if (!this.postContent || (this.isFreeUser && !this.userService.isAdmin)) {
                return null;
            }
            if (this.postContent.isStory) {
                return this.translate.instant('story.engagement.fallback_msg');
            }
            else {
                return this.translate.instant('page.post_overview.engagement_fallback_msg');
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * data will be used to send to Segment
     * @returns {{action: UserActionType; item: Page; target: ({type: Page} | {id: (number | any); name: (string | any); type: TargetType}); params: {action: UserActionType; source: ActionSource; actionDetails: ActionDetails}; activePage: {type: ActivePages}}}
     */
    PostOverviewComponent.prototype.actionData = function (target) {
        var item = target === 'project' ? Page.PROJECT : Page.CAMPAIGN;
        return {
            action: UserActionType.ACTION, item: item,
            target: {
                type: item
            },
            params: {
                action: UserActionType.UPDATE,
                source: ActionSource.ACTION_VIEW,
                actionDetails: ActionDetails.ADDED_POSTS,
            },
            activePage: {
                type: ActivePages.POST,
            }
        };
    };
    return PostOverviewComponent;
}(AbstractAchooComponent));
export { PostOverviewComponent };



// WEBPACK FOOTER //
// ./src/app/main/post-overview/post-overview.component.ts.pre-build-optimizer.js